'use strict';

class VehiclesController {
  /* @ngInject */
  constructor(VehiclesService, $scope, $q) {
    Object.assign(this, {
      VehiclesService,
      $scope,
      $q
    });

    this.query = {
      include: [],
      where: {},
      limit: 10,
      page: 1,
      order: 'plate DESC'
    };

    this.getVehicles();

    this.filter = {
      fleet: null,
      owner: null
    };

    this.onPagination = () => {
      this.getVehicles();
    };
  }

  onHolderFilterUpdate($event) {
    let clientsPromise = $event.clientsPromise;
    clientsPromise.then(clients => {
      this.holderIds = clients ? clients.map(c => c.id) : null;
      this.getVehicles();
    });
  }

  getVehicles() {
    let qOpts = JSON.parse(JSON.stringify(this.query));

    if (this.holderIds) {
      qOpts.where = Object.assign(qOpts.where, {
        holderId: { inq: this.holderIds }
      });
    }

    qOpts.where.broad = this.whereText;

    if (this.filter && this.filter.fleet == 'true') {
      qOpts.where.fleet = true;
    } else if (this.filter && this.filter.fleet == 'false') {
      qOpts.where.fleet = false;
    }

    let queryReady = this.VehiclesService.getModels(qOpts).then(vehicles => {
      this.vehicles = vehicles;
    });

    let countReady = this.VehiclesService.getCount(qOpts).then(result => {
      this.vehiclesCount = result.count;
    });

    this.promise = this.$q.all([queryReady, countReady]);
    return this.promise;
  }
}

export default VehiclesController;
